import React, { useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
// import { ForgetPasswordSchema } from "./schemas/LoginValidation";
import { Link } from "react-router-dom";

const ForgetPassword = () => {
    const Navigate = useNavigate();

    useEffect(()=>{
        const auth = localStorage.getItem('token');
        if(auth){
            Navigate('/home')
        }
    })

    const callForgetApi = (values)=>{
        console.log(values.phoneNum); //verify user number if number is valid number then send otp to user mobile nuumber and goto otp verification page 
        Navigate('/verify_otp');

    }

    const {handleSubmit,values,handleChange,errors,handleBlur,touched} = useFormik({
        initialValues:{
            phoneNum: "",
        },
        onSubmit : callForgetApi,
        // validationSchema : ForgetPasswordSchema

    })

    return (
        <div className="register">
            <h1>Forget Password</h1> 
            <form onSubmit={handleSubmit}>
                <label htmlFor="MobileNum">Mobile Number</label>
                <input 
                onChange={handleChange}
                name="phoneNum"
                id="MobileNum"
                value={values.phoneNum}
                type="tel"
                onBlur={handleBlur}
                className="inputbox"
                placeholder="Enter Your Mobile Number"
                />
                {touched.phoneNum && errors.phoneNum && (<div className="invalid-input">{errors.phoneNum}</div>)}

            <button className="submitButton" type="submit" >Send Otp</button>

            </form>
        </div>
    )
}

export default ForgetPassword;